import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Comment, Divider, Form, Modal, Segment } from 'semantic-ui-react';
import styled from 'styled-components';
import _ from 'lodash';
import moment from 'moment';
import 'moment/src/locale/it';
import NoteService from 'shared/services/api/notepratica';
import KironAvatar from 'images/kiron-icon-square.png';

const NoteContainer = styled(Segment)`
  margin: 0 -14px !important;
  padding: 22px 22px 0 !important;

  &:first-child {
    border-top: 1px solid rgb(34 36 38 / 15%) !important;
  }

  &:not(:hover) {
    button.circular {
      visibility: hidden;
    }
  }

  .ui.comments {
    float: left;
    margin-bottom: 0;
    max-width: calc(100% - 50px);

    .avatar {
      margin-top: 8px;
    }

    .content {
      margin-left: 30px !important;
      padding-right: 0;
    }
  }

  button.circular {
    font-size: 1.2em;
    margin-top: 8px;
  }
`;

const BasicNote = ({ avatar, nominativo, createdAt, descrizione }) => (
  <Comment.Group style={{ marginTop: 0 }}>
    <Comment>
      <Comment.Avatar src={avatar} style={{ marginTop: 8 }} />
      <Comment.Content style={{ marginLeft: 30 }}>
        {nominativo && <Comment.Author as="a">{nominativo}</Comment.Author>}
        {createdAt && (
          <Comment.Metadata>
            <div>{moment.unix(createdAt).locale('it').fromNow()}</div>
          </Comment.Metadata>
        )}
        <Comment.Text>{descrizione}</Comment.Text>
      </Comment.Content>
    </Comment>
  </Comment.Group>
);

BasicNote.propTypes = {
  avatar: PropTypes.string,
  nominativo: PropTypes.string,
  createdAt: PropTypes.number,
  descrizione: PropTypes.string,
};

export class SingleNote extends Component {
  state = {
    openRispondi: false,
    openDelete: false,
    message: null,
    risposta: null,
  };

  onChangeRisposta = (e) => {
    const { value } = e.target;

    if (value.length <= 1) {
      this.setState({ message: value });
    }
  };

  onCloseDeleteModal = () => this.setState({ openDelete: false });

  handleRispondi = (e) => {
    e.preventDefault();
    NoteService.reply(this.props.nota.id, this.props.nota.pratica, this.state.message)
      .then(() => this.props.update())
      .catch((err) => console.log(err));

    this.setState({
      openRispondi: false,
    });
  };

  handleRispostaButton = () =>
    this.setState({
      openRispondi: !this.state.openRispondi,
    });

  handleDelete = (e) => {
    e.preventDefault();
    this.props.delete(this.props.nota.id);
    this.setState({ openDelete: false });
  };

  handleDeleteButton = (e) => {
    e.preventDefault();
    this.setState({ openDelete: true });
  };

  render() {
    return (
      <NoteContainer clearing vertical>
        <Comment.Group>
          <Comment>
            <Comment.Avatar src={KironAvatar} />

            <Comment.Content>
              {(_.get(this.props, 'nota.createdAt') && [
                <Comment.Author as="a">
                  {_.get(this.props, 'nota.userAcl.anagrafica.nominativo') || 'Utente Campus'}
                </Comment.Author>,
                <Comment.Metadata>
                  <div>{moment.unix(this.props.nota.createdAt).locale('it').fromNow()}</div>
                </Comment.Metadata>,
              ]) || (
                <Comment.Metadata>
                  <div>Nuova nota</div>
                </Comment.Metadata>
              )}

              <Comment.Text>{this.props.nota.descrizione}</Comment.Text>

              {_.isEmpty(_.get(this.props, 'nota._embedded.children') || !this.state.risposta) && (
                <Comment.Actions>
                  {/* <Comment.Action onClick={this.handleRispostaButton}>Rispondi</Comment.Action>*/}
                </Comment.Actions>
              )}
            </Comment.Content>

            {!_.isEmpty(_.get(this.props, 'nota._embedded.children')) && (
              <BasicNote
                avatar={KironAvatar}
                nominativo={_.get(this.props, 'nota._embedded.children[0].userAcl.anagrafica.nominativo')}
                createdAt={_.get(this.props, 'nota._embedded.children[0].createdAt')}
                descrizione={_.get(this.props, 'nota._embedded.children[0].descrizione')}
              />
            )}

            {this.state.risposta && (
              <BasicNote
                avatar={KironAvatar}
                nominativo={_.get(this.state, 'risposta.userAcl.anagrafica.nominativo')}
                createdAt={_.get(this.state, 'risposta.createdAt')}
                descrizione={_.get(this.state, 'risposta.descrizione')}
              />
            )}

            {this.state.openRispondi && [
              <Form>
                <Form.TextArea
                  onBlur={(e) => this.setState({ message: e.target.value })}
                  onChange={this.onChangeRisposta}
                />
                <Button
                  disabled={!this.state.message}
                  onClick={this.handleRispondi}
                  content="Rispondi"
                  labelPosition="left"
                  icon="edit"
                  primary
                />
              </Form>,
              <Divider horizontal hidden />,
            ]}
          </Comment>
        </Comment.Group>

        <Button
          circular
          compact
          floated="right"
          icon="trash alternate outline"
          title="Elimina"
          onClick={this.handleDeleteButton}
        />

        <Modal size="mini" open={this.state.openDelete} onClose={this.onCloseDeleteModal}>
          <Modal.Header>Eliminazione nota</Modal.Header>

          <Modal.Content>
            <p>Confermi di voler eliminare la nota selezionata?</p>
          </Modal.Content>

          <Modal.Actions>
            <Button content="Annulla" onClick={this.onCloseDeleteModal} />
            <Button negative content="Conferma" onClick={this.handleDelete} />
          </Modal.Actions>
        </Modal>
      </NoteContainer>
    );
  }
}

SingleNote.propTypes = {
  nota: PropTypes.object,
  id: PropTypes.string,
  pratica: PropTypes.string,
  update: PropTypes.func,
  delete: PropTypes.func,
};

export default SingleNote;



// WEBPACK FOOTER //
// ./app/components/Note/note.js